import React, { Component } from 'react';
import { Icon } from 'antd';
import Pagination from 'yxyweb/common/components/basic/pagination'
import Modal from 'yxyweb/common/components/common/Modal';
// import { getBillingTouchOptions } from 'src/common/redux/modules/billing/config'
import * as FormatterMap from 'src/common/components/formatter';
import _ from 'lodash'
import SvgIcon from 'SvgIcon';
export default class ListTiled extends Component {
    constructor(props) {
        super(props)
        if (props.meta && (props.meta.childrenField || props.meta.cCode))
            this.viewModel = props.viewModel.get((props.meta.childrenField || props.meta.cCode))
        else
            this.viewModel = props.viewModel
        if (props.meta && props.meta.cStyle)
            this.transferCStyle(props.meta.cStyle)
        if (!this.injectDom)
            this.injectDom = 'ListTiledPay'
        this.state = {
            listShowType: 'expand',
            dataSource: props.dataSource || [],
            columns: props.columns || [],
            rowCount: 6,
            visible: false,
            pageSize: 18,
            pageIndex:1,
            currentFocus: [],
            fixedRowWidth : props.fixedRowWidth || 1000
        }

    }

    transferCStyle(cStyle){
        let config = JSON.parse(cStyle);
        if (config.formatterKey) {
            this.injectDom = config.formatterKey
        } else {
            this.injectDom = 'ListTiledPay'
        }
    }

    componentDidMount() {
        if (this.viewModel)
            this.viewModel.addListener(this)
        // let options = getBillingTouchOptions()
        // if (this.props.extraProps && this.props.extraProps.isReadTouchOption)
        //     this.isPage = options && options.basicSettingData && options.basicSettingData.flipPage == 2;
        // else
        //     this.isPage = false
    }

    componentWillUnmount() {
        if (this.viewModel)
            this.viewModel.removeListener(this);
    }

    setDataSource(data) {
        this.setState({ dataSource: data })
    }

    select(selectedRowIndexes){
        let focus = this.viewModel.getSelectedRowIndexes();
        this.setState({currentFocus: focus})
    }

    unselect(){
        let focus = this.viewModel.getSelectedRowIndexes();
        this.setState({currentFocus: focus})
    }

    setListenerState(data){
        const obj = {
            dataSource: data.rows, columns: data.columns, multiple: data.multiple, isPage: data.isPage
        }
        if (data.rowCount)
            obj.rowCount = data.rowCount
        if (data.pageSize)
            obj.pageSize = data.pageSize
        
        this.setState(obj)
    }

    expendClick = () => {
        this.setState({visible: !this.state.visible})
    }

    listItemClick = (pay, index) =>{
        if (this.props.extraProps && this.props.extraProps.itemClick)
            this.props.extraProps.itemClick(pay, index)
        if (this.state.multiple) {
            let indexes = this.viewModel.getSelectedRowIndexes();
            let i = indexes.findIndex(function (val) {
              return val == index;
            });
            if (i == -1) {
                this.viewModel.select(index, false)
                // let focus = this.state.currentFocus
                // focus.push(index + '')
                // let focus = this.viewModel.getSelectedRowIndexes();
                // this.setState({currentFocus: focus})
            }
            else {
                this.viewModel.unselect(index)
                // let focus = this.state.currentFocus
                // focus.push(index + '')
                // let focus = this.viewModel.getSelectedRowIndexes();
                // this.setState({currentFocus: focus})
            }
        } else {
            if (this.viewModel)
                this.viewModel.select(index)
            if (this.state.visible){
                this.setState({visible: false})
                // let focus = this.viewModel.getSelectedRowIndexes();
                // this.setState({currentFocus: focus || [index + ''], visible: false})
                return
            }
            // let focus = this.viewModel.getSelectedRowIndexes();
            // this.setState({currentFocus: focus || [index + '']})
        }
    }

    listItemCancelClick = (args) => {
        let { index, pay } = args
        if (this.props.extraProps && this.props.extraProps.itemCancelClick)
            this.props.extraProps.itemCancelClick(pay, index)
        if (this.state.multiple) {
            let indexes = this.viewModel.getSelectedRowIndexes();
            let i = indexes.findIndex(function (val) {
                return val == index;
            });
            if (i != -1) {
                this.viewModel.unselect(index)
                // let focus = this.state.currentFocus
                // let ii = focus.indexOf(index+'')
                // focus.splice(ii, 1)

                // let focus = this.viewModel.getSelectedRowIndexes();
                // this.setState({currentFocus: focus})
            }
        }
    }

    pageChange(page){
        this.setState({pageIndex: page})
    }

    getPagenation(originDataSource){
        let { pageSize, pageIndex } = this.state;
        return(
            <Pagination pageSize={pageSize} simple={false} total={originDataSource.length} current={pageIndex} onChange={(page) => this.pageChange(page)} />
        )
    }

    getFixedContent(originDataSource, columns, type) {
        if (_.isEmpty(originDataSource) || _.isEmpty(columns)) return <div className="listTiled_empty"></div>
        let { pageSize, pageIndex, rowCount, isPage } = this.state;
        let rowContainerStyle= {width: `${Math.floor(100/rowCount)}%`}
        let showPagenation = false, dataSource= originDataSource;
        if (type === 'fixed') dataSource = originDataSource.slice(0,rowCount)
        if (type === 'expend' && originDataSource.length > pageSize && isPage) {
            dataSource = originDataSource.slice((pageIndex-1)*pageSize, pageSize*pageIndex)
            showPagenation = true
        }
        // let containerElement = [], controlElment = []
        // _.map(dataSource, (pay, index) => {
        //     controlElment = []
        //     let realIndex = (index + (pageIndex-1) * pageSize)
        //     let isFocus = Array.isArray(currentFocus) ? currentFocus.indexOf(realIndex+'')!==-1 : currentFocus == realIndex
        //     const nameExceed = pay['name'].length > 6
        //     _.map(columns, column=>{
        //         if (column.cItemName === 'icon')
        //             controlElment.push(
        //                 <SvgIcon type={paymentIconDict[pay.paymentType] || 'tongyongzhifufangshi'} className={`${pay.paymentType == 3 || pay.paymentType == 4 ? 'payment-style-smallIcon' : ''}`} />
        //             )
        //         if (!nameExceed && column.cItemName === 'hotKey')
        //             controlElment.push(
        //                 <div className="pay-style-shortcut">{pay.hotKey}</div>
        //             )
        //         else
        //             controlElment.push(
        //                 <div className="payment-style-title">{pay[column.cItemName]}</div>
        //             )
        //     })
        //     if (controlElment.length) {
        //         let typeName = null
        //         if (pay.isDefault) {
        //             typeName = <div className='pay-style-DefaultType'>
        //                 <SvgIcon type="moren" />
        //             </div>
        //         } else if (pay.isQuick)
        //             typeName = <div className='pay-style-QuickPayType'></div>
        //         controlElment.unshift(typeName)
        //     }
        //     containerElement.push(
        //         <div onClick={()=>this.listItemClick(pay, realIndex)} className={`pay-style ${nameExceed ? 'payment-style-nameExceed' : ''} ${isFocus ? 'pay-style-focus' : ''}`} style={rowContainerStyle}>
        //             <div className="pay-style-wrapper">{controlElment}</div>
        //         </div>
        //     )

        //     // let typeName = false
        //     // if (pay.isDefault) {
        //     //     typeName = <div className='pay-style-DefaultType'>
        //     //         <SvgIcon type="moren" />
        //     //     </div>
        //     // } else if (pay.isQuick) {
        //     //     typeName = <div className='pay-style-QuickPayType'></div>

        //     // }
        //     // containerElement.push(<div style={{width: 150}} className={`pay-style ${nameExceed ? 'payment-style-nameExceed' : ''}`}>
        //     //     {typeName}
        //     //     <SvgIcon type={paymentIconDict[pay.paymentType] || 'tongyongzhifufangshi'} className={`${pay.paymentType == 3 || pay.paymentType == 4 ? 'payment-style-smallIcon' : ''}`} />
        //     //     <div className="payment-style-title">{pay.name}</div>

        //     //     {!nameExceed && (<div className="pay-style-shortcut">{pay.hotKey}</div>)}
        //     // </div>)
        // })
        let CommonDom = FormatterMap[this.injectDom];
        let containerElement = CommonDom ? <CommonDom {...this.state} dataSource={dataSource} listItemClick={this.listItemClick} rowContainerStyle={rowContainerStyle}/> : null
        let scrollOrPage = ''
        if (type === 'expend') {
            scrollOrPage = 'fixedRow-expend'
            if (isPage)
                scrollOrPage += ' fixedRow-page'
            else
                scrollOrPage += ' fixedRow-scroll'
        } else if (type === 'fixed') {
            scrollOrPage = 'fixedRow-fixed'
        }
        return <div className={`fixedRow ${scrollOrPage}`}>
                <div className="content-base">
                    <div className="rows-container">{containerElement}</div>
                    {/* <div className="rows-container">{containerElement.length ? containerElement : null}</div> */}
                    {type === 'fixed' && (originDataSource.length>rowCount) && <div className="list-expand" onClick={this.expendClick}>展开<Icon type="zhankai" /></div>}
                    {type === 'expend' && <div className="list-rollup" onClick={this.expendClick}>收起<Icon type="shouqi" /></div>}
                    {showPagenation && this.getPagenation(originDataSource)}
                </div>
            </div>
    }


    render() {
        let { listShowType, dataSource, columns, visible } = this.state;
        _.isEmpty(dataSource) && (dataSource = this.viewModel.getCache('_dataSource'))
        // _.isEmpty(columns) && (columns = this.viewModel.getColumns())
        // let fixedContent = this.getFixedContent(dataSource, columns)
        if (listShowType === 'expand') {
            if (dataSource) {
                return <div className="listTiled_content">
                {this.getFixedContent(dataSource, columns, visible ? 'expend' : 'fixed')}
                    </div>
            }else{
                return <div className='ListAreaMapDisplay_ListArea'><div className=" table-nodata "><SvgIcon type="nodata"/>暂时没有数据哦~</div></div>
            }
           
        }
        return (<div className="listTiled_content">
            {this.getFixedContent(dataSource, columns, 'fixed')}
            <Modal
            visible={visible}
            closable={false}
            maskClosable={false}
            onOk={this.expendClick}
            className='listTiled-modal'
            wrapClassName='listTiled-modal-wrap'
            >
                {this.getFixedContent(dataSource, columns, 'expend')}
            </Modal>
        </div>)
    }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/meta/ListTiled.jsx